import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from './useLanguage';

export const usePageTitle = (title?: string) => {
  const location = useLocation();
  const { t } = useLanguage();

  useEffect(() => {
    // Se viene passato un titolo specifico, usalo
    if (title) {
      console.log('usePageTitle: Setting custom title:', title);
      document.title = title;
      return;
    }

    // Altrimenti, genera il titolo basato sulla route
    const generateTitle = () => {
      const path = location.pathname;
      
      switch (path) {
        case '/':
          return 'La Dolce Vita - Abruzzo Travel Experiences';
        case '/about-us':
          return `${t('aboutUs.title')} - La Dolce Vita`;
        case '/contact':
          return `${t('contact.title')} - La Dolce Vita`;
        case '/login':
          return `${t('auth.loginTitle')} - La Dolce Vita`;
        case '/signup':
          return `${t('auth.signupTitle')} - La Dolce Vita`;
        case '/privacy-policy':
          return 'Privacy Policy - La Dolce Vita';
        case '/terms-and-conditions':
          return 'Terms and Conditions - La Dolce Vita';
        case '/account':
          return 'Account - La Dolce Vita';
        case '/profile':
          return 'Profile - La Dolce Vita';
        case '/checkout':
          return 'Checkout - La Dolce Vita';
        case '/admin':
          return 'Admin Dashboard - La Dolce Vita';
        case '/admin/users':
          return 'Admin Users - La Dolce Vita';
        case '/admin/messages':
          return 'Admin Messages - La Dolce Vita';
        case '/admin/analytics':
          return 'Admin Analytics - La Dolce Vita';
        case '/payment-success':
        case '/payment-return':
          return 'Payment Success - La Dolce Vita';
        case '/payment-cancel':
          return 'Payment Cancelled - La Dolce Vita';
        case '/payment-error':
          return 'Payment Error - La Dolce Vita';
        default:
          // Per route dinamiche come /trip/:id, /destination/:id, /activities/:id
          if (path.startsWith('/trip/')) {
            const tripId = path.split('/')[2];
            return `Trip ${tripId} - La Dolce Vita`;
          }
          if (path.startsWith('/destination/')) {
            const destinationId = path.split('/')[2];
            return `Destination ${destinationId} - La Dolce Vita`;
          }
          if (path.startsWith('/activities/')) {
            const activityId = path.split('/')[2];
            return `Activity ${activityId} - La Dolce Vita`;
          }
          return 'La Dolce Vita - Abruzzo Travel Experiences';
      }
    };

    const newTitle = generateTitle();
    console.log('usePageTitle: Setting generated title:', newTitle);
    document.title = newTitle;
  }, [location.pathname, title, t]);

  return null;
};
